import localForage from 'localforage'
import jwtDecode from 'jwt-decode'
import moment from 'moment'

const config = require('../../config')

const LOAD = 'dofe-web/auth/LOAD'
const LOAD_SUCCESS = 'dofe-web/auth/LOAD_SUCCESS'
const LOAD_FAIL = 'dofe-web/auth/LOAD_FAIL'

const LOGIN = 'dofe-web/auth/LOGIN'
const LOGIN_SUCCESS = 'dofe-web/auth/LOGIN_SUCCESS'
const LOGIN_FAIL = 'dofe-web/auth/LOGIN_FAIL'

const MFA_VERIFY = 'dofe-web/auth/MFA_VERIFY'
const MFA_VERIFY_SUCCESS = 'dofe-web/auth/MFA_VERIFY_SUCCESS'
const MFA_VERIFY_FAIL = 'dofe-web/auth/MFA_VERIFY_FAIL'

const REFRESH = 'dofe-web/auth/REFRESH'
const REFRESH_SUCCESS = 'dofe-web/auth/REFRESH_SUCCESS'
const REFRESH_FAIL = 'dofe-web/auth/REFRESH_FAIL'

const GET_CSFR_TOKEN = 'dofe-web/auth/GET_CSFR_TOKEN'
const GET_CSFR_TOKEN_SUCCESS = 'dofe-web/auth/GET_CSFR_TOKEN_SUCCESS'
const GET_CSFR_TOKEN_FAIL = 'dofe-web/auth/GET_CSFR_TOKEN_FAIL'

const LOGOUT = 'dofe-web/auth/LOGOUT'
const LOGOUT_SUCCESS = 'dofe-web/auth/LOGOUT_SUCCESS'
const LOGOUT_FAIL = 'dofe-web/auth/LOGOUT_FAIL'

const SAVE_USER = 'dofe-web/auth/SAVE_USER'
const SAVE_USER_SUCCESS = 'dofe-web/auth/SAVE_USER_SUCCESS'
const SAVE_USER_FAIL = 'dofe-web/auth/SAVE_USER_FAIL'

const SET_ACTIVE_ORG = 'dofe-web/auth/SET_ACTIVE_ORG'

const CHECK_AUTH_CODE = 'dofe-bo/common/CHECK_AUTH_CODE'
const CHECK_AUTH_CODE_SUCCESS = 'dofe-bo/common/CHECK_AUTH_CODE_SUCCESS'
const CHECK_AUTH_CODE_FAIL = 'dofe-bo/common/CHECK_AUTH_CODE_FAIL'

const REFRESH_BLOB_ACCESS = 'dofe-bo/common/REFRESH_BLOB_ACCESS'
const REFRESH_BLOB_ACCESS_SUCCESS = 'dofe-bo/common/REFRESH_BLOB_ACCESS_SUCCESS'
const REFRESH_BLOB_ACCESS_FAIL = 'dofe-bo/common/REFRESH_BLOB_ACCESS_FAIL'

const initialState = {
  loaded: false
}

export default function reducer (state = initialState, action = {}) {
  let tempUser
  let extendBy
  let currentUnixTime

  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      }
    case LOAD_SUCCESS:
      tempUser = config.autoLogin ? state.user : null

      return {
        ...state,
        loading: false,
        loaded: true,
        user: action.result ? action.result : tempUser
      }
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case LOGIN:
      return {
        ...state,
        loggingIn: true
      }
    case LOGIN_SUCCESS:
      // document.cookie = `AuthorizationCode=${action.result
      //   .blobAccessAuthorizationCode}`

      return {
        ...state,
        loggingIn: false,
        user: {
          ...action.result
          // expires_in: moment().add(action.result.expires_in, 'minutes') // eslint-disable-line
          // expires_in: moment().add(1, 'minutes') // eslint-disable-line
        }
      }
    case LOGIN_FAIL:
      return {
        ...state,
        loggingIn: false,
        user: null,
        loginError: action.error
      }
    case MFA_VERIFY:
      return {
        ...state,
        loggingIn: true
      }
    case MFA_VERIFY_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        user: {
          ...action.result
        }
      }
    case MFA_VERIFY_FAIL:
      return {
        ...state,
        loggingIn: false,
        user: null,
        loginError: action.error
      }
    case REFRESH:
      return {
        ...state,
        loggingIn: true,
        refreshingToken: true
      }
    case REFRESH_SUCCESS:
      currentUnixTime = moment().unix() * 1000
      extendBy = action.result.expires_in * 1000

      return {
        ...state,
        refreshingToken: false,
        user: {
          ...state.user,
          ...action.result,
          exp: currentUnixTime + extendBy
        }
      }
    case REFRESH_FAIL:
      return {
        ...state,
        loggingIn: false,
        refreshingToken: false,
        user: null,
        loginError: action.error
      }
    case LOGOUT:
      return {
        ...state,
        loggingOut: true
      }
    case LOGOUT_SUCCESS:
      return {
        ...state,
        loggingOut: false,
        user: null
      }
    case LOGOUT_FAIL:
      return {
        ...state,
        loggingOut: false,
        logoutError: action.error
      }
    case SAVE_USER:
      return {
        ...state
      }
    case SAVE_USER_SUCCESS:
      return {
        ...state
      }
    case SAVE_USER_FAIL:
      return {
        ...state
      }
    case SET_ACTIVE_ORG:
      localForage
        .setItem('activeOrganization', action.data)
        .catch(console.error)

      return {
        ...state,
        organization: action.data
      }

    default:
      return state
  }
}

export function isLoaded (globalState) {
  return globalState.auth && globalState.auth.loaded
}

export function load () {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get('/loadAuth')
  }
}

/* eslint-disable */
export function login (data, clientId = 'frontoffice-web') {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: client =>
      client.post('/authenticate', {
        data: {
          ...data,
          client_id: clientId
        }
      })
  }
}

/* eslint-enable */

/* eslint-disable */
export function loginBulk (data) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: client =>
      client.post('/authenticateBulk', { data })
  }
}

export function mfaVerify (data) {
  return {
    types: [MFA_VERIFY, MFA_VERIFY_SUCCESS, MFA_VERIFY_FAIL],
    promise: client =>
      client.post('/authenticate/mfa/verify', { data })
  }
}

/* eslint-enable */

export function saveUser (response) {
  const data = {
    ...response,
    ...jwtDecode(response.access_token)
    // expires_in: moment().add(response.expires_in, 'minutes') // eslint-disable-line
    // expires_in: moment().add(1, 'minutes') // eslint-disable-line
  }

  return {
    types: [SAVE_USER, SAVE_USER_SUCCESS, SAVE_USER_FAIL],
    promise: client => client.post('/save-user', { data })
  }
}

export function saveUserBo (data) {
  return {
    types: [SAVE_USER, SAVE_USER_SUCCESS, SAVE_USER_FAIL],
    promise: client => client.post('/save-user-bo', { data })
  }
}

export function logout () {
  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: client => client.post('/logout')
  }
}

export function refreshAccessToken (token, options = {}) {
  return {
    types: [REFRESH, REFRESH_SUCCESS, REFRESH_FAIL],
    promise: client =>
      client.post('/tokens', {
        data: {
          refresh_token: token, // eslint-disable-line
          options
        },
        removeToken: true
      })
  }
}

export function getCSRFToken () {
  return {
    types: [GET_CSFR_TOKEN, GET_CSFR_TOKEN_SUCCESS, GET_CSFR_TOKEN_FAIL],
    promise: client => client.get('api/tokens/csrf/get')
  }
}

export function getORBg02CSRFToken () {
  return {
    types: [GET_CSFR_TOKEN, GET_CSFR_TOKEN_SUCCESS, GET_CSFR_TOKEN_FAIL],
    promise: client => client.get('apiv2/authentication/token/csrf/get')
  }
}

export function setActiveOrg (data) {
  return {
    type: SET_ACTIVE_ORG,
    data
  }
}

export function isValidAuthCode (authCode) {
  return {
    types: [CHECK_AUTH_CODE, CHECK_AUTH_CODE_SUCCESS, CHECK_AUTH_CODE_FAIL],
    promise: client =>
      client.get(
        `api/authorization-code/check-validity?authorizationCode=${authCode}`,
        {
          removeToken: true
        }
      )
  }
}

export function refreshBlobAccess (authCode) {
  const data = { authorizationCode: authCode }
  return {
    types: [REFRESH_BLOB_ACCESS, REFRESH_BLOB_ACCESS_SUCCESS, REFRESH_BLOB_ACCESS_FAIL],
    promise: client => client.post(`api/authorization-code/refresh-blob-access`, { data })
  }
}


